import { render, staticRenderFns } from "./approval.vue?vue&type=template&id=986055f6&scoped=true"
import script from "./approval.vue?vue&type=script&lang=js"
export * from "./approval.vue?vue&type=script&lang=js"
import style0 from "./approval.vue?vue&type=style&index=0&id=986055f6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "986055f6",
  null
  
)

export default component.exports